module.exports = ".pnlAcesso{\n    width: 80%;\n    margin: 0 auto;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/acesso/acesso.component.css
// module id = ./src/app/acesso/acesso.component.css
// module chunks = main